import { render, staticRenderFns } from "./announce-banner.vue?vue&type=template&id=fa08b84e&scoped=true&"
import script from "./announce-banner.vue?vue&type=script&lang=js&"
export * from "./announce-banner.vue?vue&type=script&lang=js&"
import style0 from "./announce-banner.vue?vue&type=style&index=0&id=fa08b84e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa08b84e",
  null
  
)

export default component.exports